import { defineMessages } from 'react-intl';

export default defineMessages({

  tripCancellation: {
    id: 'fastCover.tripCancellationStep.tripCancellation',
    defaultMessage: 'Are you claiming for Trip Cancellation?',
  },

  haveYouReceivedReimbursement: {
    id: 'fastCover.tripCancellationStep.haveYouReceivedReimbursement',
    defaultMessage: 'Have you received reimbursement?',
  },

  travelDelay: {
    id: 'fastCover.tripCancellationStep.travelDelay',
    defaultMessage: 'Are you claiming for Travel Delay?',
  },

  reasons1: {
    id: 'fastCover.tripCancellationStep.reasons1',
    defaultMessage: 'Death of an Immediate Family Member',
  },

  reasons2: {
    id: 'fastCover.tripCancellationStep.reasons2',
    defaultMessage: 'Your Unforeseen Sickness or Injury or, the Sickness or Injury of a Traveling Companion or Immediate Family Member',
  },

  reasons3: {
    id: 'fastCover.tripCancellationStep.reasons3',
    defaultMessage: 'Substantial destruction of your principal residence by fire or weather-related activity',
  },

  reasons4: {
    id: 'fastCover.tripCancellationStep.reasons4',
    defaultMessage: 'A Medically Necessary covered Emergency Medical Evacuation to return to Your Home Country or to the area from which You were initially evacuated for continued treatment, recuperation, and recovery',
  },

  travelSupplier: {
    id: 'fastCover.tripCancellationStep.travelSupplier',
    defaultMessage: 'Travel Supplier / Provider Information',
  },

  includedInPackage: {
    id: 'fastCover.tripCancellationStep.includedInPackage',
    defaultMessage: 'If not included in package, how was air travel arranged?',
  },

  lossInformation: {
    id: 'fastCover.tripCancellationStep.lossInformation',
    defaultMessage: 'Loss Information',
  },

  addLossInformation: {
    id: 'fastCover.tripCancellationStep.addLossInformation',
    defaultMessage: 'Add Loss Information',
  },

  lossInformationWithIdx: {
    id: 'fastCover.tripCancellationStep.lossInformationWithIdx',
    defaultMessage: 'Loss information {idx}',
  },

  nameOfPersonHavingSickness: {
    id: 'fastCover.tripCancellationStep.nameOfPersonHavingSickness',
    defaultMessage: 'Name of person having sickness of injury',
  },

  dateOfBirth: {
    id: 'fastCover.tripCancellationStep.dateOfBirth',
    defaultMessage: 'His/Her date of birth',
  },

  relationshipToClaimant: {
    id: 'fastCover.tripCancellationStep.relationshipToClaimant',
    defaultMessage: 'His/Her relationship to claimant',
  },

  dateSicknessOrInjuryBegan: {
    id: 'fastCover.tripCancellationStep.dateSicknessOrInjuryBegan',
    defaultMessage: 'Date Sickness Or Injury began',
  },

  dateEnded: {
    id: 'fastCover.tripCancellationStep.dateEnded',
    defaultMessage: 'Date ended',
  },

  natureOfSicknessOrInjury: {
    id: 'fastCover.tripCancellationStep.natureOfSicknessOrInjury',
    defaultMessage: 'Nature of Sickness or Injury (If Injury, describe accident, including date and place):',
  },

  periodOfHospitalization: {
    id: 'fastCover.tripCancellationStep.periodOfHospitalization',
    defaultMessage: 'Period of hospitalization (If applicable)',
  },

  companyNameLoss: {
    id: 'fastCover.tripCancellationStep.companyNameLoss',
    defaultMessage: 'Company name (airline/hotel/cruise/travel agent/etc.)',
  },

  amountPaidLoss: {
    id: 'fastCover.tripCancellationStep.amountPaidLoss',
    defaultMessage: 'Amount Paid',
  },

  amountOfLoss: {
    id: 'fastCover.tripCancellationStep.amountOfLoss',
    defaultMessage: 'Amount of Loss (non-refundable amount)',
  },

  howMuchReceivedReimbursement: {
    id: 'fastCover.tripCancellationStep.howMuchReceivedReimbursement',
    defaultMessage: 'How much?',
  },

  fromWhom: {
    id: 'fastCover.tripCancellationStep.fromWhom',
    defaultMessage: 'If so, from whom?',
  },

  reasonsForDelay: {
    id: 'fastCover.tripCancellationStep.reasonsForDelay',
    defaultMessage: 'Reasons for Delay',
  },

  reasons1ForTravelDelay: {
    id: 'fastCover.tripCancellationStep.reasons1ForTravelDelay',
    defaultMessage: 'Delay of a Common Carrier (including Inclement Weather)',
  },

  reasons2ForTravelDelay: {
    id: 'fastCover.tripCancellationStep.reasons2ForTravelDelay',
    defaultMessage: 'Delay by a traffic Accident enroute to a departure, in which You or Your Traveling Companion is not directly involved',
  },

  reasons3ForTravelDelay: {
    id: 'fastCover.tripCancellationStep.reasons3ForTravelDelay',
    defaultMessage: 'Delay due to lost or stolen passport, travel documents or money, Quarantine, hijacking, unannounced Strike, Natural Disaster, civil commotion, or riot',
  },

  reasons4ForTravelDelay: {
    id: 'fastCover.tripCancellationStep.reasons4ForTravelDelay',
    defaultMessage: 'A closed roadway causing cessation of travel to the destination of the Trip (substantiated by the department of transportation, state police, etc.)',
  },

  dateYouWereDueToDepart: {
    id: 'fastCover.tripCancellationStep.dateYouWereDueToDepart',
    defaultMessage: 'Date you were due to depart',
  },

  timeYouWereDueToDepart: {
    id: 'fastCover.tripCancellationStep.timeYouWereDueToDepart',
    defaultMessage: 'Time you were due to depart',
  },

  dateTripWasDelayed: {
    id: 'fastCover.tripCancellationStep.dateTripWasDelayed',
    defaultMessage: 'Date trip was delayed with Travel Supplier',
  },

  dateYouActuallyDeparted: {
    id: 'fastCover.tripCancellationStep.dateYouActuallyDeparted',
    defaultMessage: 'Date you actually departed',
  },

  timeYouActuallyDeparted: {
    id: 'fastCover.tripCancellationStep.timeYouActuallyDeparted',
    defaultMessage: 'Time you actually departed',
  },

  delayInformation: {
    id: 'fastCover.tripCancellationStep.delayInformation',
    defaultMessage: 'Delay Information',
  },

  addDelayInformation: {
    id: 'fastCover.tripCancellationStep.addDelayInformation',
    defaultMessage: 'Add Delay Information',
  },

  delayInformationWithIdx: {
    id: 'fastCover.tripCancellationStep.delayInformationWithIdx',
    defaultMessage: 'Delay information {idx}',
  },
  dateReimbursementReceived: {
    id: 'fastCover.tripCancellationStep.dateReimbursementReceived',
    defaultMessage: 'Date Reimbursement Received',
  },

  yes: {
    id: 'fastCover.tripCancellationStep.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.tripCancellationStep.no',
    defaultMessage: 'No',
  },
  fromDate: {
    id: 'fastCover.tripCancellationStep.fromDate',
    defaultMessage: 'From Date',
  },
  toDate: {
    id: 'fastCover.tripCancellationStep.toDate',
    defaultMessage: 'To Date',
  },

  //-----------------------------------------------------------------------------------------

  howItHappened: {
    id: 'fastCover.tripCancellationStep.howItHappened',
    defaultMessage: '1. How it happened',
  },
  whereYouWereInRelationToTheItem: {
    id: 'fastCover.tripCancellationStep.whereYouWereInRelationToTheItem',
    defaultMessage:
      'Provide details of where you were in relation to the item at the time of loss, theft or damage',
  },
  anyThingAdditionalToAdd: {
    id: 'fastCover.tripCancellationStep.anyThingAdditionalToAdd',
    defaultMessage: 'Do you have any further details to add?',
  },
  areYouClaimingFor: {
    id: 'fastCover.tripCancellationStep.areYouClaimingFor',
    defaultMessage: 'Are you claiming for',
  },
  loss: {
    id: 'fastCover.tripCancellationStep.loss',
    defaultMessage: 'Loss',
  },
  theft: {
    id: 'fastCover.tripCancellationStep.theft',
    defaultMessage: 'Theft',
  },
  damage: {
    id: 'fastCover.tripCancellationStep.damage',
    defaultMessage: 'Damage',
  },
  delay: {
    id: 'fastCover.tripCancellationStep.delay',
    defaultMessage: 'Delay',
  },
  whoDidYouReportThisTo: {
    id: 'fastCover.tripCancellationStep.whoDidYouReportThisTo',
    defaultMessage: 'Who did you report this to?',
  },
  police: {
    id: 'fastCover.tripCancellationStep.police',
    defaultMessage: 'Police',
  },
  hotelManagement: {
    id: 'fastCover.tripCancellationStep.hotelManagement',
    defaultMessage: 'Hotel Management',
  },
  cruiseShip: {
    id: 'fastCover.tripCancellationStep.cruiseShip',
    defaultMessage: 'Cruise Ship',
  },
  airline: {
    id: 'fastCover.tripCancellationStep.airline',
    defaultMessage: 'Airline',
  },
  tourGuide: {
    id: 'fastCover.tripCancellationStep.tourGuide',
    defaultMessage: 'Tour Guide',
  },
  other: {
    id: 'fastCover.tripCancellationStep.other',
    defaultMessage: 'Other',
  },
  notReported: {
    id: 'fastCover.tripCancellationStep.notReported',
    defaultMessage: 'Not Reported',
  },
  otherDescription: {
    id: 'fastCover.tripCancellationStep.otherDescription',
    defaultMessage: 'If other, please describe',
  },
  reportReferenceNumber: {
    id: 'fastCover.tripCancellationStep.reportReferenceNumber',
    defaultMessage: 'Report Reference Number',
  },
  descriptionOfItem: {
    id: 'fastCover.tripCancellationStep.descriptionOfItem',
    defaultMessage: 'Description of item',
  },
  datePurchased: {
    id: 'fastCover.tripCancellationStep.datePurchased',
    defaultMessage: 'Date purchased',
  },
  storeWhereItemWasPurchased: {
    id: 'fastCover.tripCancellationStep.storeWhereItemWasPurchased',
    defaultMessage: 'Store where item was purchased',
  },
  purchasePrice: {
    id: 'fastCover.tripCancellationStep.purchasePrice',
    defaultMessage: 'Purchase price',
  },
  currency: {
    id: 'fastCover.tripCancellationStep.currency',
    defaultMessage: 'Currency',
  },
  amountClaimed: {
    id: 'fastCover.tripCancellationStep.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  proofOfPurchaseAttached: {
    id: 'fastCover.tripCancellationStep.proofOfPurchaseAttached',
    defaultMessage: 'Proof of purchase attached',
  },
  addAdditionalItem: {
    id: 'fastCover.tripCancellationStep.addAdditionalItem',
    defaultMessage: 'Add Additional Item',
  },
  additionalItem: {
    id: 'fastCover.tripCancellationStep.additionalItem',
    defaultMessage: 'Luggage and Personal Items',
  },
  item: {
    id: 'fastCover.tripCancellationStep.item',
    defaultMessage: 'Item',
  },
  claimed: {
    id: 'fastCover.tripCancellationStep.claimed',
    defaultMessage: 'Claimed',
  },
  nameOfTransportProvider: {
    id: 'fastCover.tripCancellationStep.nameOfTransportProvider',
    defaultMessage:
      'Name of Transport Provider (airline, cruise liner, bus etc.)',
  },
  dateWhenYourLuggageWasDelayed: {
    id: 'fastCover.tripCancellationStep.dateWhenYourLuggageWasDelayed',
    defaultMessage: 'Date when your luggage was delayed',
  },
  timeWhenYourLuggageWasDelayed: {
    id: 'fastCover.tripCancellationStep.timeWhenYourLuggageWasDelayed',
    defaultMessage: 'Time when your luggage was delayed',
  },
  dateWhenYourLuggageWasReturned: {
    id: 'fastCover.tripCancellationStep.dateWhenYourLuggageWasReturned',
    defaultMessage: 'Date when your luggage was returned',
  },
  timeWhenYourLuggageWasReturned: {
    id: 'fastCover.tripCancellationStep.timeWhenYourLuggageWasReturned',
    defaultMessage: 'Time when your luggage was returned',
  },
  paidForDelay: {
    id: 'fastCover.tripCancellationStep.paidForDelay',
    defaultMessage: 'Were you paid any compensation for this delay?',
  },
  madeClaimWithTravelProviderOrOther: {
    id: 'fastCover.tripCancellationStep.madeClaimWithTravelProviderOrOther',
    defaultMessage:
      'Have you made a claim with your Travel Provider (Airline, hotel, cruise liner, tour company etc.) or any other company responsible for the loss, theft, damage or delay of your luggage?',
  },
  listedOnThePolicy: {
    id: 'fastCover.tripCancellationStep.listedOnThePolicy',
    defaultMessage:
      'Are the luggage or personal item(s) lost, stolen, damaged or delayed owned by you or someone else listed on the policy?',
  },
  damagedLostOrStolenLuggageItems: {
    id: 'fastCover.tripCancellationStep.damagedLostOrStolenLuggageItems',
    defaultMessage: 'Damaged, Lost or Stolen Luggage Items',
  },
  delayedLuggageExpenses: {
    id: 'fastCover.tripCancellationStep.delayedLuggageExpenses',
    defaultMessage: 'Delayed Luggage Expenses',
  },
  delayedLuggageExpense: {
    id: 'fastCover.tripCancellationStep.delayedLuggageExpense',
    defaultMessage: 'Delayed Luggage Expense',
  },
  isRequired: {
    id: 'fastCover.tripCancellationStep.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  expenseTableRequired: {
    id: 'fastCover.tripCancellationStep.expenseTableRequired',
    defaultMessage: 'Expense table fields are mandatory fields.',
  },
  addDelayedLuggageExpense: {
    id: 'fastCover.tripCancellationStep.addDelayedLuggageExpense',
    defaultMessage: 'Add Delayed Luggage Expense',
  },
  dateCompensationWasReceived: {
    id: 'fastCover.tripCancellationStep.dateCompensationWasReceived',
    defaultMessage: 'Date compensation was received',
  },
  compensationDescription: {
    id: 'fastCover.tripCancellationStep.compensationDescription',
    defaultMessage: 'Compensation description',
  },
  amountOfCompensation: {
    id: 'fastCover.tripCancellationStep.delayedTravel.amountOfCompensation',
    defaultMessage: 'Compensation received',
  },
  amountOfCompensationCurrency: {
    id: 'fastCover.tripCancellationStep.delayedTravel.amountOfCompensationCurrency',
    defaultMessage: 'Currency',
  },
  currencyEg: {
    id: 'fastCover.tripCancellationStep.currencyEg',
    defaultMessage: 'E.g.Euro',
  },
  other1: {
    id: 'fastCover.tripCancellationStep.other1',
    defaultMessage: 'Proof of loss (i.e. police report, report to hotel, airline, transport provider)',
  },
  other2: {
    id: 'fastCover.tripCancellationStep.other2',
    defaultMessage: 'Proof of ownership/receipts/bank statements for each item',
  },
  other3: {
    id: 'fastCover.tripCancellationStep.other3',
    defaultMessage: 'Written confirmation of an IMEI block from your network provider',
  },
  other4: {
    id: 'fastCover.tripCancellationStep.other4',
    defaultMessage: 'A damage/repair report or quotation',
  },
  other5: {
    id: 'fastCover.tripCancellationStep.other5',
    defaultMessage: 'Written confirmation of luggage delay',
  },
  other6: {
    id: 'fastCover.tripCancellationStep.other6',
    defaultMessage: 'Receipts, bank statements and/or proof of payment for each expense being claimed',
  },
  itemWithIdx: {
    id: 'fastCover.tripCancellationStep.itemWithIdx',
    defaultMessage: 'Item {idx}',
  },
  delayedLuggageExpenseWithIdx: {
    id: 'fastCover.tripCancellationStep.delayedLuggageExpenseWithIdx',
    defaultMessage: 'Delayed Luggage Expense {idx}',
  },
  checkEventDate: {
    id: 'fastCover.tripCancellationStep.checkEventDate',
    defaultMessage: "'{defaultMessage}' cannot be in the future.",
  },
  areYouCancellingTheTripDueToMedicalReasons: {
    id: 'fastCover.medicalExpenseStep.areYouCancellingTheTripDueToMedicalReasons',
    defaultMessage: 'Are you cancelling the trip due to medical reasons?',
  },
  dateTripWasCancelledWithTravelSupplier: {
    id: 'fastCover.tripCancellationStep.dateTripWasCancelledWithTravelSupplier',
    defaultMessage: 'Date Trip was cancelled with Travel Supplier',
  },
  reasonForCancellation: {
    id: 'fastCover.tripCancellationStep.reasonForCancellation',
    defaultMessage: 'Reason For Cancellation',
  },
  areYouInterruptingTheTripDueToMedicalReasons: {
    id: 'fastCover.tripCancellationStep.areYouInterruptingTheTripDueToMedicalReasons',
    defaultMessage: 'Are you interrupting the trip due to medical reasons?',
  },
  schoolName: {
    id: 'fastCover.tripCancellationStep.schoolName',
    defaultMessage: 'School Name',
  },
  dateTripWasDelayedWithTravelSupplier: {
    id: 'fastCover.tripCancellationStep.dateTripWasDelayedWithTravelSupplier',
    defaultMessage: 'Date Trip was delayed with Travel Supplier',
  },
  detailsRegardingYourTripDelay: {
    id: 'fastCover.tripCancellationStep.dateTripWasDelayedWithTravelSupplier',
    defaultMessage: 'Details regarding your Trip Delay',
  },
  dateDelayEnded: {
    id: 'fastCover.tripCancellationStep.dateDelayEnded',
    defaultMessage: 'Date delay ended',
  },
  reasonsForTripInterruption: {
    id: 'fastCover.tripCancellationStep.reasonsForTripInterruption',
    defaultMessage: 'Reasons for Trip Interruption',
  },

  companyNameTravelInterruption: {
    id: 'fastCover.tripDelayStep.companyNameTravelInterruption',
    defaultMessage: 'Company Name',
  },

  addressTravelInterruption: {
    id: 'fastCover.tripDelayStep.addressTravelInterruption',
    defaultMessage: 'Address',
  },

  cityTravelInterruption: {
    id: 'fastCover.tripDelayStep.cityTravelInterruption',
    defaultMessage: 'City',
  },

  stateTravelInterruption: {
    id: 'fastCover.tripDelayStep.stateTravelInterruption',
    defaultMessage: 'State',
  },

  zipCodeTravelInterruption: {
    id: 'fastCover.tripDelayStep.zipCodeTravelInterruption',
    defaultMessage: 'Zip code',
  },

  contactTravelInterruption: {
    id: 'fastCover.tripDelayStep.contactTravelInterruption',
    defaultMessage: 'Contact',
  },

  phoneNumber: {
    id: 'fastCover.tripDelayStep.phoneNumber',
    defaultMessage: 'Phone Number',
  },

  areYouClaimingForAirlineReissueOrCancellationFees: {
    id: 'fastCover.tripDelayStep.areYouClaimingForAirlineReissueOrCancellationFees',
    defaultMessage: 'Are you claiming for Airline Reissue or Cancellation Fees?',
  },

  areYouClaimingForReinstateFrequentTravelerAwards: {
    id: 'fastCover.tripDelayStep.areYouClaimingForReinstateFrequentTravelerAwards',
    defaultMessage: 'Are you claiming to Reinstate Frequent Traveler Awards?',
  },

  dateOfInitialPaymentDeposit: {
    id: 'fastCover.tripCancellationStep.dateOfInitialPaymentDeposit',
    defaultMessage: 'Date of initial payment deposit',
  },

  insureds: {
    id: 'fastCover.tripCancellationStep.addInsured',
    defaultMessage: 'Name(s) and birthdates of all claimants:',
  },

  birthDay: {
    id: 'fastCover.tripCancellationStep.birthDay',
    defaultMessage: 'Birth Day',
  },

  fullName: {
    id: 'fastCover.tripCancellationStep.fullName',
    defaultMessage: 'Full Name',
  },

  addInsured: {
    id: 'fastCover.tripCancellationStep.addInsured',
    defaultMessage: 'Add Insured',
  },

  insuredInformationWithIdx: {
    id: 'fastCover.tripCancellationStep.insuredInformationWithIdx',
    defaultMessage: 'Insured Information {idx}',
  },

  dateOfLoss: {
    id: 'fastCover.tripCancellationStep.dateOfLoss',
    defaultMessage: 'Date Of Loss',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.TripCancellationStep/messages.js